// ENTITY fr.gestionpial.pial.dto.RepartitionPropositionDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { AeshAffectationActiveDTO } from './AeshAffectationActiveDTO';
import { PropositionAffectationDTO } from './PropositionAffectationDTO';
import { PreferenceAesh } from './PreferenceAesh';
import { EtapeTraceDTO } from './EtapeTraceDTO';

export class RepartitionPropositionDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.RepartitionPropositionDTO';

  nbAesh: number | null = 0;
  nbEcoles: number | null = 0;
  totalAffecte: number | null = 0;
  propositions: PropositionAffectationDTO[] | null = [];
  warnings: string[] | null = [];
  preferences: PreferenceAesh[] | null = [];
  aeshDejaAffecteesADate: AeshAffectationActiveDTO[] | null = [];
  trace: EtapeTraceDTO[] | null = [];

  constructor(init?:Partial<RepartitionPropositionDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.RepartitionPropositionDTO'] = RepartitionPropositionDTO;

fields['fr.gestionpial.pial.dto.RepartitionPropositionDTO']  = {
    nbAesh: 'java.lang.Integer',
    nbEcoles: 'java.lang.Integer',
    totalAffecte: 'java.lang.Integer',
    propositions: 'java.util.List<fr.gestionpial.pial.dto.PropositionAffectationDTO>',
    warnings: 'java.util.List<java.lang.String>',
    preferences: 'java.util.List<fr.gestionpial.pial.entities.PreferenceAesh>',
    aeshDejaAffecteesADate: 'java.util.List<fr.gestionpial.pial.dto.AeshAffectationActiveDTO>',
    trace: 'java.util.List<fr.gestionpial.pial.dto.EtapeTraceDTO>'
};
